import React, { Component } from 'react'
import styled from 'styled-components'
import NavItem from './NavItem'
import { Link } from 'react-scroll'

const Wrapper = styled.nav`
  display: flex;
  width: 100%;
  justify-content: center;
`

class ScrollNav extends Component {
  render () {
    const { items } = this.props
    return (
      <Wrapper>
        {items.map((item, index) => (
          <Link
            key={index}
            activeClass='active'
            to={item.name.toLowerCase()}
            spy
            smooth
            duration={500}
            offset={-265}
          >
            <NavItem icon={item.icon}>{item.name}</NavItem>
          </Link>
        ))}
      </Wrapper>
    )
  }
}

export default ScrollNav



// WEBPACK FOOTER //
// ./src/components/UI/ScrollNav/index.js